import React from 'react';

import { trans, getResourcePath } from '@spotahome/soyuz/client';

import Section from '@spotahome/ui-library/lib/components/Section';

import Hero from '../../common/components/Hero';
import HeaderContainer from '../../common/components/HeaderContainer';
import Footer from '../../common/components/Footer';
import Apply from '../../common/components/Apply';
import Cookies from '../../common/components/Cookies';
import SessionExpiredModal from '../../common/components/SessionExpiredModal';
import AppBanner from '../../common/components/AppBanner';

import WhyJoin from './components/WhyJoin';
import HowItWorks from './components/HowItWorks';
import LookingForyou from './components/LookingForYou';

// Styles
import './../../common/scss/init.scss';
import './main.scss';

const CALL_TO_ACTION_URL = 'https://201821.typeform.com/to/gwAlbO';

const AmbassadorContainer = () => (
  <div>
    <Hero
      menu={<HeaderContainer tracking="ga-ambassadors" />}
      title={trans('ambassador.alt.hero.title')}
      subtitle={trans('ambassador.alt.hero.subtitle')}
      backgroundImage={`url(${getResourcePath(
        '/images/ambassador/ambassador-header.jpg'
      )})`}
      callToActionText="hero.apply-now"
      callToActionPath={CALL_TO_ACTION_URL}
    />

    <Section background="light" className="ambassador__looking-for-you">
      <LookingForyou />
    </Section>

    <Section background="light" className="ambassador__hiw">
      <HowItWorks />
    </Section>

    <Section background="light" className="ambassador__why-join">
      <WhyJoin />
    </Section>

    <Section background="dark">
      <Apply
        actionUrl={CALL_TO_ACTION_URL}
        headingText={trans('ambassador.apply.title')}
        descriptionText={trans('ambassador.apply.description')}
      />
    </Section>
    <Footer />
    <SessionExpiredModal />
    <Cookies />
    <AppBanner />
  </div>
);

export default AmbassadorContainer;
